<template>
  <div id="batch">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <h1>Captura del Lote {{currentBatch.id}} <span v-if="currentBatch.status === 'CLOSE'">(Cerrado)</span></h1>
          <h2> {{currentBatch.label}} </h2>
          <h2> {{currentBatch.send_date | formatDate}} </h2>
        </v-flex>
        <v-flex xs12 class="text-xs-center">
          <v-dialog v-model="updateBatchDialog" max-width="500px">
          <v-btn  slot="activator" color="success">Actualizar</v-btn>
          <batch-batch-form
            :batch="currentBatch"
            v-on:close-batch-data="updateBatchDialog = false"
            v-on:error="onUpdateBatchError"
            v-on:success="onUpdateBatchSuccess"
           />
        </v-dialog>
          <v-btn v-if="currentBatch.status !== 'CLOSE'" color="success" @click="closeBatch">Cerrar Lote</v-btn>
          <v-btn color="success" @click="getMetalLoadFile">Carga de Metal</v-btn>
        </v-flex>
        <v-flex xs12 class="text-xs-center">
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center" >
              <h3>Sacos</h3>
            </v-flex>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="currentBatch.bags"
                class="elevation-1"
                hide-actions
                no-data-text="No hay informacion que mostrar"
              >
                <template v-slot:items="props">
                  <td><router-link :to="bagLink(props.item)">Saco No. {{ props.item.batch_consecutive }}</router-link></td>
                  <td>{{ props.item.type }} Grade</td>
                  <td v-if="props.item.type === 'HIGH'">{{ props.item.real_pieces }} ({{ props.item.whole_pieces }})</td>
                  <td v-if="props.item.type === 'LOW'"> - </td>
                  <td v-if="props.item.type === 'METAL'"> - </td>
                  <td v-if="props.item.type === 'HIGH'">{{ props.item.pounds }}</td>
                  <td v-if="props.item.type === 'LOW'">{{ props.item.dust }}</td>
                  <td v-if="props.item.type === 'METAL'"> - </td>
                  <td>{{ statusDescription(props.item.status) }}</td>
                  <td>{{ props.item.routes }}</td>
                  <td class="justify-center layout px-0">
                    <!--v-icon
                      small
                      @click="props.expanded = !props.expanded">
                      expand_more
                    </v-icon-->
                    <v-icon
                      v-if="props.item.status === 'OPEN'"
                      small
                      @click="closeBag(props.item)"
                    >
                      lock
                    </v-icon>
                    <v-icon
                      v-if="props.item.status === 'CLOSE'"
                      small
                      @click="openBag(props.item)"
                    >
                      lock_open
                    </v-icon>
                  </td>
                </template>
                <template v-slot:expand="props">
                  <v-card flat>
                    <v-card-text>Bag detail</v-card-text>
                  </v-card>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12>
              <v-dialog v-model="showNewBagDialog" max-width="500px">
                <v-btn v-if="currentBatch.status !== 'CLOSE'" slot="activator" color="success">Nuevo Saco</v-btn>
                <v-form  v-model="isNewBagValid" onSubmit="return false;">
                <v-card>
                  <v-card-title primary-title>
                    <h1>Nuevo Saco</h1>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-select
                            label="Contenido"
                            :items="bagTypes"
                            v-model="newBag.type"
                            item-text="label"
                            item-value="value"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="closeNewBagDialog">Cancelar</v-btn>
                    <v-btn color="blue-grey darken-2 white--text" @click="createNewBag" :disabled="!isNewBagValid">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
                </v-form>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>
<script>

import { getCurrentBatch, createNewBatch, closeBatch } from '../services/batch';
import { createNewBag, openBag, closeBag } from '../services/bag';

import _ from 'lodash';
import download from 'js-file-download';

export default {
  data() {
    return {
      currentBatch: {},
      defaultBatch: {
        id: 0,
        description: '',
        created_on: undefined,
        closed_on: undefined,
        created_by: undefined,
        closed_by: undefined,
        status: undefined,
      },
      headers: [
        { text: 'Saco', value: 'batch_consecutive'},
        { text: 'Contenido', value: 'type' },
        { text: 'Piezas', value: 'real_pieces' },
        { text: 'Libras', value: 'pounds' },
        { text: 'Estado', value: 'status' },
        { text: 'Rutas', value: 'routes' },
        { text: 'Operaciones', sortable: false },
      ],
      bagTypes: [
        { label: 'HIGH', value: 'HIGH' },
        { label: 'LOW', value: 'LOW' },
      ],
      newBag: {
        type: 'HIGH',
      },
      defaultNewBag: {
        type: 'HIGH',
      },
      showNewBagDialog: false,
      isNewBagValid: false,
      required: [
        (v) => !!v || 'Campo requerido',
      ],

      updateBatchDialog: false,
    };
  },
  methods: {
    bagLink(bag) {
      return `/bag/${bag.id}`;
    },
    async closeBatch() {
      try {
        const result = await closeBatch(this.currentBatch.id);
        this.getOrCreateCurrentBatch();
      } catch (error) {
        this.$emit('error', error.message);
      }
    },
    statusDescription(status) {
      const descriptions = {
        OPEN: 'Abierto',
        CLOSE: 'Cerrado',
      };
      return descriptions[status];
    },
    async getOrCreateCurrentBatch() {
      try {
        const currentBatchresponse = await getCurrentBatch();
        this.currentBatch = Object.assign({}, currentBatchresponse.data);
        if (_.isEmpty(this.currentBatch)) {
          const newBatchResponse = await createNewBatch();
          this.currentBatch = Object.assign({}, newBatchResponse.data);
        }
      } catch (error) {
        this.$emit('error', error.message);
      }
    },
    async createNewBag() {
      try {
        const result = await createNewBag(this.currentBatch.id, this.newBag.type);
        if (this.currentBatch.bags) {
          this.currentBatch.bags.push(Object.assign({ routes: 0 }, result.data));
        }
        this.newBag = Object.assign({}, this.defaultNewBag);
        this.showNewBagDialog = false;
      } catch (error) {
        this.$emit('error', error.message);
      }
    },
    async closeNewBagDialog() {
      this.showNewBagDialog = false;
      this.newBag = Object.assign({}, this.defaultNewBag);
    },
    async closeBag(bag) {
      const result = await closeBag(bag.id);
      bag.status = result.data.status;
    },
    async openBag(bag) {
      const result = await openBag(bag.id);
      bag.status = result.data.status;
    },
    async getMetalLoadFile() {
      const options = {
        responseType: 'blob',
      };
      this.axios.get(`/metalload/${this.currentBatch.id}/xls`, options)
      .then((result) => {
        download(result.data, `Carga de Metal_Lote_${this.currentBatch.id}.xls`);
      })
      .catch((error) => {
        this.$emit('error', error.message);
      });
    },
    onUpdateBatchError(event) {
      this.$emit('error', event);
    },
    onUpdateBatchSuccess(event) {
      this.updateBatchDialog = false;
      this.$emit('success', 'Datos del lote actualizados');
    },
  },

  async mounted() {
    try {
      if (!this.$route.params.id) {
        await this.getOrCreateCurrentBatch();
      } else {
        this.axios.get(`/batch/detail/${this.$route.params.id}`)
          .then( (result) => {
             this.currentBatch = Object.assign({}, result.data);
          });
      }
    } catch (error) {
      this.$emit('error', error.message);
    }
  },
};
</script>